import { ISelectOptions } from "./ScmTypes";
import { SupplierDictCodeEnmu } from "./supplierDictEnums";

//供应商类别
export const supplierCategoryOption: ISelectOptions[] = [
    {label:"贸易商",value: SupplierDictCodeEnmu.SUPPLIER_CATEGORY_TRADERS},
    {label:"服务站",value: SupplierDictCodeEnmu.SUPPLIER_CATEGORY_SERVICESTATION},
    {label:"经销商",value: SupplierDictCodeEnmu.SUPPLIER_CATEGORY_DEALER},
]

//供应商企业性质
export const supplierEnterpriseNatureOption: ISelectOptions[] = [
    {label:"企业",value: SupplierDictCodeEnmu.SUPPLIER_ENTERPRISENATURE_ENTERPRISE},
    {label:"个人",value: SupplierDictCodeEnmu.SUPPLIER_ENTERPRISENATURE_PERSON},
    {label:"销商务站",value: SupplierDictCodeEnmu.SUPPLIER_ENTERPRISENATURE_SALESBUSINESSSTATION},
]


//供应商类型
export const supplierTypeOption: ISelectOptions[] = [
    {label:"主机厂配件",value: SupplierDictCodeEnmu.SUPPLIER_TYPE_OEMACCESSORIES},
    {label:"OE件",value: SupplierDictCodeEnmu.SUPPLIER_TYPE_OECOMPONENT},
    {label:"工时",value: SupplierDictCodeEnmu.SUPPLIER_TYPE_WORKINGHOURS},
    {label:"经销商",value: SupplierDictCodeEnmu.SUPPLIER_TYPE_DEALER},
]



//询价对比单据壮腰
export const inquiryStatusOption: ISelectOptions[] = [
    {label:"已开单",value: SupplierDictCodeEnmu.INQUIRY_STATUS_CREATE},
    {label:"已提交",value: SupplierDictCodeEnmu.INQUIRY_STATUS_SUBMIT},
]

